import { cookieStorage } from '@pflegia/ui/storage/cookie-storage';

import { POSTHOG_COOKIE_KEY } from '../utils/constants';

export const useFeatureFlagCookieData = <Payload, Variant = unknown>(featureFlagName: string) => {
  const storedData = cookieStorage.getItem(POSTHOG_COOKIE_KEY);
  let parsedData;
  try {
    parsedData = JSON.parse(storedData || '{}');
  } catch {
    parsedData = {};
  }
  if (typeof parsedData !== 'object' || parsedData === null) {
    parsedData = {};
  }

  return {
    cookieVariant: parsedData['featureFlags']?.[featureFlagName] as Variant,
    cookiePayload: parsedData['featureFlagPayloads']?.[featureFlagName] as Payload,
  };
};
